import React, { useEffect, useState } from "react";

import ConfirmDeleteModal from "../components/common/ConfirmDeleteModal";
import MemberModal from "../components/member/MemberModal";
import DataTable from "../components/common/DataTable";
import { api_paths } from "../config/api.paths";
import API from "../config/axios";
import { useSelector } from "react-redux";
import { formatToUSDate } from "../utils/dateFormat";

function RegisterMembership() {
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const { user } = useSelector((state) => state.USER_DATA);

  const customPrimaryRow = {
    _id: "primary-custom-row",
    first_name: `${user?.first_name || ""} ${user?.last_name || ""}`,
    date_of_birth: formatToUSDate(user?.date_of_birth?.split("T")[0]),
    gender: user?.gender
      ? user.gender.charAt(0).toUpperCase() + user.gender.slice(1)
      : "",
    marital_status: user?.marital_status || "",
    relationship: "Primary",
  };

  const fetchMembers = async () => {
    try {
      const response = await API.get(api_paths.member.family_member.GET_MEMBER);

      if (response.status === 200) {
        setMembers(response?.data?.payload?.result || []);
      }
    } catch (error) {
      console.error("Error fetching members:", error);
    }
  };

  const membershipColumns = [
    {
      key: "first_name",
      label: "Name",
      render: (_, row) => `${row.first_name || ""} ${row.last_name || ""}`,
    },
    {
      key: "date_of_birth",
      label: "Date of Birth",
      render: (val) => formatToUSDate(val?.split("T")[0]),
    },
    { key: "gender", label: "Gender" },
    { key: "relationship", label: "Relation" },
    {
      key: "membership_status",
      label: "Membership",
      render: (_, row) => {
        if (row.is_child) {
          return "Free"; // Children are always Free
        }

        if (row.is_membership_active) {
          return "Active";
        } else if (!row.is_membership_active && !row.is_child) {
          return row.membership_id ? "Expired" : "Pending";
        }

        return "Unknown"; // fallback
      },
    },
  ];

  useEffect(() => {
    const loadData = async () => {
      await Promise.all([fetchMembers()]);
    };

    loadData();
  }, []);

  const handleDelete = async (row) => {
    setSelectedRow(row);
    setShowDeleteModal(true);
  };
  const handleDeleteConfirmed = async (row) => {
    if (!row?._id || row.relationship === "Primary") return;

    try {
      setLoading(true);
      await API.delete(
        `${api_paths.member.family_member.DELETE_MEMBER}/${row._id}`
      );

      const response = await API.get(api_paths.member.family_member.GET_MEMBER);

      setMembers(response.data.payload.result || []);
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete member. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-8">
            <h1 className="inter-bold member-ship-title">
              Family Members ({members.length + 1})
            </h1>
          </div>
          <div className="col-lg-4 d-flex justify-content-lg-end align-items-center">
            <button
              className="btn btn-lg btn-orange"
              onClick={() => {
                setEditData(null);
                setShowModal(true);
              }}
            >
              Add Member
            </button>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-lg-12">
          <DataTable
            columns={membershipColumns}
            data={[customPrimaryRow, ...members]}
            loading={loading}
            onEdit={(row) => {
              if (row.relationship !== "Primary") {
                setEditData(row);
                setShowModal(true);
              }
            }}
            onDelete={handleDelete}
          />
          </div>
        </div>
      </div>

      <MemberModal
        show={showModal}
        onHide={() => setShowModal(false)}
        editData={editData}
        refreshList={fetchMembers}
      />

      <ConfirmDeleteModal
        show={showDeleteModal}
        onCancel={() => setShowDeleteModal(false)}
        onConfirm={() => {
          handleDeleteConfirmed(selectedRow);
          setShowDeleteModal(false);
        }}
      />
    </div>
  );
}

export default RegisterMembership;
